import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Router from 'vue-router'

// 兼容写法
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 完整加载
import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)
import store from "./store";

// 引入样式
import(`./styles/mobile.scss`);

import api from './utils/api'
Vue.prototype.$api = api;

// 返回顶部插件
import vueToTop from 'vue-totop'
Vue.use(vueToTop)

// 引入vant-ui
import Vant from "vant";
import 'vant/lib/index.css';
Vue.use(Vant);

import qs from 'qs'

import VueResource from "vue-resource";
Vue.use(VueResource);

import "./utils/filters";
import './utils/mixin'
import axios from "@/utils/axios.js";
Vue.prototype.$axios = axios;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
